import React, { useMemo } from 'react';
import { MdCalendarToday, MdPeople, MdComment , MdWarning } from 'react-icons/md';
import '../../style/ToDoCards.css';

const ToDoCard = ({
    title,
    statusId,
    assignee = "MI",
    dueDate,
    associatedCount,
    commentCount,
    onClick
}) => {

    // Function to get background color based on status ID
    const statusBg = useMemo(() => {
        switch (statusId) {
            case 1: // To Do
                return 'linear-gradient(180deg, #ffd700 0%, #ffed4e 100%)'; // Blue
            case 2: // In Progress
                return 'linear-gradient(180deg, #ff9800 0%, #ffb74d 100%)'; // Orange
            case 3: // Review
                return 'linear-gradient(180deg, #e91e63 0%, #f06292 100%)'; // Pink
            case 4: // Completed
                return 'linear-gradient(180deg, #4caf50 0%, #81c784 100%)'; // Green
            default:
                return 'linear-gradient(180deg, #ffd700 0%, #ffed4e 100%)'; // Default Yellow
        }
    }, [statusId]);

    return (
        <div className="todo-card" onClick={onClick}>
            {/* Status-based Left Border */}
            <div
                className="card-left-border"
                style={{ background: statusBg }} />

            {/* Card Content */}
            <div className="card-content">
                <h3 className="card-title">{title}</h3>
                <div className="card-footer">
                    <div className="card-footer-left">
                        <span className="assignee" style={{ background: statusBg }}>{assignee}</span>
                        <div className="associated-count">
                            <MdPeople size={15} />
                            <span>{associatedCount}</span>
                            <MdComment className='ms-1' size={15} />
                            <span>{commentCount}</span>
                        </div>
                    </div>
                    {dueDate && (
                        <div className="card-footer-right">
                            {new Date(dueDate) < new Date() ? (
                                // Overdue
                                <div className="due-date" style={{ color: "red" }}>
                                    <MdWarning size={15} /> {/* Alert icon */}
                                    <span>{dueDate}</span>
                                </div>
                            ) : (
                                // Still valid
                                <div className="due-date">
                                    <MdCalendarToday size={15} />
                                    <span>{dueDate}</span>
                                </div>
                            )}
                        </div>
                    )}


                </div>
            </div>
        </div>
    );
};

export default ToDoCard;